import { EventBus } from 'relapp-event';

export default {
    methods: {
        /**
         * Scalable place for multiple validation checks.
         *
         * @returns {boolean}
         */
        validateOverviewOptions() {
            return this.validateHosting();
        },

        /**
         * Validate Hosting packages.
         *
         * @returns {boolean}
         */
        validateHosting() {
            const self = this;
            let valid = true;

            Object.values(this.order.subscriptions.hosting).every(function(hostingPackage) {
                if (self.isForwardOrder(hostingPackage)) {
                    const pattern = new RegExp(
                        '^(https?:\\/\\/)?' +
                            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
                            '((\\d{1,3}\\.){3}\\d{1,3}))' +
                            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                            '(\\?[;&a-z\\d%_.~+=-]*)?' +
                            '(\\#[-a-z\\d_]*)?$',
                        'i'
                    );

                    if (hostingPackage.forwarding_url) {
                        valid = true;
                        if (! hostingPackage.forwarding_url.match(pattern)) {
                            valid = self.emitValidationMessage('message.error.validation_forwarding');
                        }

                        return valid;
                    }
                    valid = self.emitValidationMessage('message.error.validation_forwarding');
                }
            });

            return valid;
        },

        /**
         * Is the hosting package of the type doorstuur?
         *
         * @param {object} hostingPackage
         *
         * @returns {boolean}
         */
        isForwardOrder(hostingPackage) {
            return (hostingPackage.name === 'forwarding' || hostingPackage.name === 'Doorsturen');
        },

        /**
         * emit a validation related message.
         *
         * @param {string} messageTransKey
         *
         * @return {boolean}
         */
        emitValidationMessage(messageTransKey) {
            EventBus.$emit('notification', {
                type: 'error',
                message: trans(messageTransKey)
            });

            return false;
        }
    }
}
